import './scss/pages/archive-programs.scss';
import { SearchFilters } from './js/front/search-filters';
import { CampusesTooltips } from './js/front/campuses';

window.addEventListener( 'DOMContentLoaded', () => {

	const searchFilters = new SearchFilters();
	const tooltips = new CampusesTooltips();
	searchFilters.initSearchfilters();
	tooltips.toggleTooltips();

} );
